import { Cross, Tick } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import Typography from "ds/components/Typography";

import { WebhookIntegrationWithTimestamp } from "../types";

const ModuleWebhooksTableStatusCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<WebhookIntegrationWithTimestamp>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Box direction="row" align="center" gap="small">
        <Icon src={webhook.enabled ? Tick : Cross} color={webhook.enabled ? "success" : "danger"} />
        <Typography tag="span" variant="p-body3" color={webhook.enabled ? "success" : "danger"}>
          {webhook.enabled ? "Enabled" : "Disabled"}
        </Typography>
      </Box>
    </TableSimpleCell>
  );
};

export default ModuleWebhooksTableStatusCell;
